import { render, staticRenderFns } from "./TrackBullionHistory.vue?vue&type=template&id=52307885&scoped=true&"
import script from "./TrackBullionHistory.vue?vue&type=script&lang=js&"
export * from "./TrackBullionHistory.vue?vue&type=script&lang=js&"
import style0 from "./TrackBullionHistory.vue?vue&type=style&index=0&id=52307885&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52307885",
  null
  
)

export default component.exports